import { Dispatch } from 'redux';
import { connect } from 'react-redux';

import { createRequestActiveClientsAction } from 'actions/clientActions';
import { ClippingPlatformState } from 'store/clippingPlatformState';
import { getAll } from 'store/selectors';
import { ApiDataTypes } from 'api/apiDataTypes';
import ClientsTable from './clientsTable';

function mapStateToProps(state: ClippingPlatformState) {
  return {
    clients: getAll(state.entities.clients),
    allClientsLoaded: state.appStatus.allLoaded[ApiDataTypes.ActiveClients],
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    loadAllClients: (c: any) => dispatch(createRequestActiveClientsAction(c, dispatch)),
  };
}

export const ActiveClientsTableContainer = connect(mapStateToProps, mapDispatchToProps)(ClientsTable);
